import * as types from '../actions/ActionTypes';

const initialState = {
  loading: false,
  categoriesList: [],
  categoriesDropdownList: [],
  categoryRecord: null,
  redirectToList: false,
  validation_error: "",
  showUpdateForm: false,
  showViewPage: false,
  formState: {}
};

const TimesheetCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CATEGORIES_REQUEST:
      return { ...state, loading: true, redirectToList: false, validation_error: "" };
    case types.CATEGORIES_SUCCESS:
      return { ...state, loading: false, categoriesList: action.categoriesList };
    case types.CATEGORIES_DROPDOWN_SUCCESS:
      return { ...state, loading: false, categoriesDropdownList: action.categoriesDropdownList };
    case types.CATEGORIES_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryRecord: action.record,
        formState: action.record, // Initialize formState with record data
        showUpdateForm: action.actionType === 'update',
        showViewPage: action.actionType === 'view',
      };
    case types.CATEGORIES_VALIDATION_ERROR: 
      return { ...state, loading: false, validation_error: action.validation_error };
    case types.CATEGORIES_REDIRECT:
      return {
        ...state,
        redirectToList: true,
        showUpdateForm: false,
        showViewPage: false,
        categoryRecord: null,
        formState: {},
        validation_error: ""
      };
    case types.HIDE_CATEGORIES_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key]) {
          const new_validation_error = { ...state.validation_error };
          delete new_validation_error[action.feild_key];
          return { ...state, validation_error: new_validation_error };
      }
      return state;
    default:
      return state;
  }
};

export default TimesheetCategoryReducer;
